export default {
  title: 'Domestic OneWay',
  href: '/docs/flights/oneway',
  sections: [
    {
      title: 'Search',
      link: '/docs/flights/oneway/search',
      tag: 'POST',
    },
    {
      title: 'Fare Rules',
      link: '/docs/flights/oneway/fare-rules',
      tag: 'POST',
    },
    {
      title: 'Seat Map',
      link: '/docs/flights/oneway/seat-map',
      tag: 'POST',
    },
    {
      title: 'Review Flight',
      link: '/docs/flights/oneway/review',
      tag: 'POST',
    },
    {
      title: 'Hold Flight',
      link: '/docs/flights/oneway/hold',
      tag: 'POST',
    },
    {
      title: 'Booking Session',
      link: '/docs/flights/oneway/session',
      tag: 'GET',
    },
    {
      title: 'Sync Book',
      link: '/docs/flights/oneway/book-flight',
      tag: 'POST',
    },
    {
      title: 'Async Book',
      link: '/docs/flights/oneway/async-book-apis',
      tag: 'POST',
    },
    {
      title: 'Retrieve Booking',
      link: '/docs/flights/oneway/retrieve-booking',
      tag: 'GET',
    },
  ],
};
